import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative bg-background py-20 lg:py-28 overflow-hidden">
      
      {/* Background Decor */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full z-0 pointer-events-none">
        <div className="hidden lg:block absolute top-0 right-0 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[120px] opacity-60" />
        <div className="hidden lg:block absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent/5 rounded-full blur-[100px] opacity-50" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-semibold mb-8 border border-primary/20">
            <Icon name="Zap" size={16} />
            <span>End-to-End Automation Catalog</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary mb-6 leading-tight tracking-tight">
            Everything You Need to <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
              Run on Autopilot
            </span>
          </h1>
          
          <p className="text-lg sm:text-xl text-text-secondary mb-10 max-w-3xl mx-auto leading-relaxed">
            Stop stitching together random tools. We provide a complete ecosystem of intelligent automation services designed to work together.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Link to="/contact">
              <Button variant="default" size="lg" iconName="Calendar" iconPosition="left" className="w-full sm:w-auto shadow-lg shadow-primary/25">
                Book a Solution Audit
              </Button>
            </Link>
            <Link to="#catalog">
              <Button variant="outline" size="lg" iconName="ArrowDown" iconPosition="right" className="w-full sm:w-auto">
                Browse Solutions
              </Button>
            </Link>
          </div>
          
          {/* Quick Stats Strip */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            {[
              { icon: 'Clock', label: 'Time Saved', value: '40-70 Hrs/mo' },
              { icon: 'TrendingUp', label: 'Avg ROI', value: '300%' },
              { icon: 'Users', label: 'Clients', value: '500+' },
              { icon: 'ShieldCheck', label: 'Guarantee', value: '100%' }
            ].map((stat, index) => (
              <div key={index} className="bg-card/50 backdrop-blur-sm rounded-xl p-4 border border-border flex flex-col items-center justify-center text-center hover:bg-card transition-colors">
                <Icon name={stat.icon} className="w-5 h-5 sm:w-6 sm:h-6 text-primary mb-2" />
                <div className="text-lg font-bold text-text-primary">{stat.value}</div>
                <div className="text-xs text-text-secondary uppercase tracking-wide">{stat.label}</div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;